export default __webpack_public_path__ + "static/media/privacidad.1621350a.pdf";